import React from 'react';
import { IOldIconProps } from './type';

const UltraFresh: React.FC<IOldIconProps> = ({ width, height, ...props }) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.0339 19.9366V6.13987C17.0339 4.65898 15.8831 3.46864 14.4716 3.46864C13.0602 3.46864 11.9094 4.66835 11.9094 6.13987V19.9366C10.7227 20.7895 9.94952 22.2048 9.94952 23.8169C9.94952 26.4225 11.9723 28.5314 14.4716 28.5314C16.971 28.5314 18.9938 26.4225 18.9938 23.8169C18.9938 22.2048 18.2116 20.7895 17.0339 19.9366Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4599 6.13987C11.4599 4.40953 12.8119 3 14.4716 3C16.1304 3 17.4834 4.39908 17.4834 6.13987V19.6987C18.6668 20.6451 19.4433 22.1321 19.4433 23.8169C19.4433 26.6813 17.2192 29 14.4716 29C11.7241 29 9.5 26.6813 9.5 23.8169C9.5 22.1334 10.2674 20.6452 11.4599 19.6977V6.13987ZM14.4716 3.93727C13.3084 3.93727 12.3589 4.92717 12.3589 6.13987V19.9366C12.3589 20.0907 12.2862 20.2349 12.1645 20.3224C11.0939 21.0919 10.399 22.3659 10.399 23.8169C10.399 26.1637 12.2206 28.0627 14.4716 28.0627C16.7227 28.0627 18.5443 26.1637 18.5443 23.8169C18.5443 22.3674 17.8416 21.0921 16.7774 20.3214C16.6565 20.2339 16.5844 20.0901 16.5844 19.9366V6.13987C16.5844 4.91887 15.6359 3.93727 14.4716 3.93727Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2835 18.0151C18.2835 17.7563 18.4848 17.5465 18.7331 17.5465H22.0505C22.2987 17.5465 22.5 17.7563 22.5 18.0151C22.5 18.274 22.2987 18.4838 22.0505 18.4838H18.7331C18.4848 18.4838 18.2835 18.274 18.2835 18.0151Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2835 14.8003C18.2835 14.5415 18.4848 14.3317 18.7331 14.3317H21.574C21.8223 14.3317 22.0235 14.5415 22.0235 14.8003C22.0235 15.0591 21.8223 15.2689 21.574 15.2689H18.7331C18.4848 15.2689 18.2835 15.0591 18.2835 14.8003Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2835 11.3792C18.2835 11.1204 18.4848 10.9106 18.7331 10.9106H20.8368C21.0851 10.9106 21.2863 11.1204 21.2863 11.3792C21.2863 11.6381 21.0851 11.8479 20.8368 11.8479H18.7331C18.4848 11.8479 18.2835 11.6381 18.2835 11.3792Z"
        fill="black"
      />
      <path
        d="M15.5954 20.4989L15.5235 13.863C15.5235 13.2163 15.0111 12.7008 14.3907 12.7008C13.7704 12.7008 13.2759 13.2257 13.2759 13.8724V20.5645C12.1881 21.0988 11.2711 22.411 11.2711 23.7419C11.2711 25.5883 12.7006 27.0786 14.4716 27.0786C16.2427 27.0786 17.6722 25.5789 17.6722 23.7419C17.6722 22.4016 16.6833 21.0238 15.5954 20.4895V20.4989Z"
        fill="#3C71DA"
      />
    </svg>
  );
};

export default UltraFresh;
